export default __webpack_public_path__ + "static/media/franceBrand.4239409c.svg";